import React from 'react'
import './index.scss'

export default function Popup({title, children, closePopup, contentStyles, headStyles}) {
  return (
      <div className="popup">
        <div className="popup__content" style={contentStyles}>
          <div className="popup__content-head" style={headStyles}>
            <p className="popup__title">{title}</p>
            <div onClick={closePopup} className="popup__close"><img src='/assets/icons/close.svg' alt=""/></div>
          </div>
          {children}
        </div>
        <div onClick={closePopup} className="popup__bg"></div>
      </div>
  )
}
